window.fcWidget.on("widget:loaded", function (resp) {
  //Function to do some task
  const chatNow = document.querySelector(".chat-now");
  if (chatNow) {
    const chatNowLabel = document.querySelector(".chat-now__label");
    if (chatNowLabel) {
      chatNowLabel.innerHTML = "Chat Now";
    }
    chatNow.disabled = false;
    chatNow.addEventListener("click", () => {
      if (window.fcWidget.isOpen() != true) {
        window.fcWidget.open();
      }
    });
  }
});
